// extracted by css-extract-rspack-plugin
export default {"tooltip":"tooltip-FA1bV","arrow":"arrow-2hvEu","default":"default-2Hsns","label":"label-2usAQ"};